import request from '@/utils/request';

export type EnterpriseAssociation = {
  feature_available?: boolean;
  state?: string;
  application_id?: string;
  application_version?: number;
  membership_id?: string;
  enterprise?: { display_name?: string; display_name_masked?: string };
  applied_at?: string;
  expires_at?: string;
  reviewed_at?: string;
  joined_at?: string;
  can_start_new_application?: boolean;
  can_withdraw?: boolean;
  can_reapply_same_enterprise?: boolean;
};

export const getEnterpriseAssociation = () =>
  request.get<EnterpriseAssociation>('/answer/api/v1/enterprise/team-association', {
    ignoreError: '50X',
  });

export const applyEnterpriseAssociation = (
  data: Record<string, unknown>,
  idempotencyKey: string,
) =>
  request.post<EnterpriseAssociation>(
    '/answer/api/v1/enterprise/team-association/applications',
    data,
    { headers: { 'Idempotency-Key': idempotencyKey } },
  );

export const withdrawEnterpriseAssociation = (
  applicationID: string,
  data: Record<string, unknown>,
  idempotencyKey: string,
) =>
  request.post<EnterpriseAssociation>(
    `/answer/api/v1/enterprise/team-association/applications/${encodeURIComponent(applicationID)}/withdraw`,
    data,
    { headers: { 'Idempotency-Key': idempotencyKey } },
  );

export const isEnterpriseMember = (association?: EnterpriseAssociation | null) =>
  association?.feature_available === true &&
  association.state === 'approved' &&
  Boolean(association.membership_id);
